import ApolloClient from 'apollo-boost';
import store from 'store';

export const client = new ApolloClient({
  uri: `${GRAPHQL_API}/gql`,
  watchQuery: {
    fetchPolicy: 'no-cache',
  },
  query: {
    fetchPolicy: 'no-cache',
  },
  request: async (operation) => {
    operation.setContext({
      headers: {
        authorization: store.get('token'),
        ['x-honeycomb-chapter']: '696428f8dabfb10cd265df52',
      },
    });
  },
});

export function watchQuery(client, opts, cb) {
  const query = client.watchQuery(opts);
  const subscription = query.subscribe({
    next: (nextResult) => {
      cb(nextResult);
    },
    error: (error) => {
      cb({ error, loading: false });
    },
  });

  return [query, subscription];
}

export default client;
